export const MAX_ATTRIBUTE_NAME_LENGTH = 255;

// From two attributes on, the order can be set in the Define Attributes Order panel.
export const MIN_ATTRIBUTES_TO_ORDER = 2;
